export default "__VITE_ASSET__DQpH$XUn__"